import usePaginatedNotifications from '~/hooks/useLoaders/usePaginatedNotifcations';

import { ComponentErrorBoundary } from '../ComponentErrorBoundary';
import NotificationsRenderer from './NotificationsRenderer';

const NotificationsOnSuccessfulFetch = () => {
  const { notifications, isLoading, notificationsCount, fetchMoreNotifications, hasMoreToFetch } =
    usePaginatedNotifications();

  return (
    <NotificationsRenderer
      notificationsCount={notificationsCount}
      isLoading={isLoading}
      notifications={notifications}
      fetchMoreNotifications={fetchMoreNotifications}
      hasMoreToFetch={hasMoreToFetch}
    />
  );
};

const Notifications = () => {
  return (
    <ComponentErrorBoundary
      fallbackRender={() => (
        <NotificationsRenderer notificationsCount={0} isLoading={false} notifications={[]} hasMoreToFetch={false} />
      )}
    >
      <NotificationsOnSuccessfulFetch />
    </ComponentErrorBoundary>
  );
};

export default Notifications;
